import React from 'react'
import ActionBtn from './ActionBtn'
import logoIcon from '../images/logo.png'
import styled from 'styled-components'

const Hero = () => {
	return (
		<HeroContainer>
			<img src={logoIcon} alt='logo' className='logo' />
			<HeroContent>
				<HeroTitle>
					Get Anonymous <span className='gradient-text'>Q&A</span>
				</HeroTitle>
				<HeroDescription>
					Ask anything, get private answers. <br />
					Enrich your social network with Whispr.
				</HeroDescription>
				<ActionBtn appStoreReferrer='pt=122259015&ct=whispr_ad&mt=8' />
			</HeroContent>
		</HeroContainer>
	)
}

const HeroContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	.logo {
		width: 326px;
		margin-top: 20px;
	}
	@media (max-width: 768px) {
		height: 70vh;
		.logo {
			margin-top: 100px;
			width: 278px;
		}
	}
`

const HeroContent = styled.div`
	transform: translateY(30%);
	@media (max-width: 768px) {
		transform: none;
		// margin-top: 20px;
	}
`

const HeroTitle = styled.h1`
	font-size: 65px;
	font-weight: 900;
	transform: scaleY(1.2);
	margin: 20px 0;
	.gradient-text {
		background: linear-gradient(90deg, #b4f6ff 0%, #8effbb 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
	@media (max-width: 768px) {
		margin: 0;
		font-size: 22px;
	}
`

const HeroDescription = styled.p`
	font-size: 25px;
	font-weight: 400;
	margin: 0 auto 70px auto;
	padding-bottom: 10px;
	width: 550px;
	line-height: 31px;
	transform: scaleY(1.2);
	text-align: center;
	@media (max-width: 768px) {
		display: none;
	}
`

export default Hero
